/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-05 15:48:09
 * @LastEditTime: 2020-10-27 09:29:26
 * @Description: 销售项目store
 */
import {
  getCustomerQZUpdateForm,
  createCustomerQZUpdateForm,
  reviewCustomerQZUpdateForm,
  deleteCustomerQZUpdateForm,
  removeBannedUserQZ
} from '@/api/customerQZUpdateForm';
import Vue from 'vue'
import customer from './customer'

const state = {
  customerQZUpdateFormList: [],
  totalCounts: 0
}

const getters = {}

const actions = {
  async getCustomerQZUpdateFormAction({
    commit
  }, payload) {
    try {
      const res = await getCustomerQZUpdateForm(payload)
      commit('SET_CUSTOMER_QZ_UPDATE_FORM', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
  async createCustomerQZUpdateFormAction({
    commit
  }, payload) {
    try {
      const newCustomerQZUpdateForm = await createCustomerQZUpdateForm(payload);
      commit('ADD_CUSTOMER_QZ_UPDATE_FORM', newCustomerQZUpdateForm.data)
    } catch (error) {
      throw error.message
    }
  },
  async reviewCustomerQZUpdateFormAction({
    commit
  }, payload) {
    try {
      await reviewCustomerQZUpdateForm(payload.id, payload.data)
    } catch (error) {
      throw error.message
    }
  },
  async deleteCustomerQZUpdateFormAction({
    commit
  }, payload) {
    try {
      await deleteCustomerQZUpdateForm(payload)
      commit('DELETE_CUSTOMER_QZ_UPDATE_FORM', payload)
    } catch (error) {
      throw error.message
    }
  },
  async removeBannedUserQZAction({
    commit
  }, payload) {
    try {
      await removeBannedUserQZ(payload)
    } catch (error) {
      throw error.message
    }
  }
}

const mutations = {
  SET_CUSTOMER_QZ_UPDATE_FORM(state, payload) {
    state.customerQZUpdateFormList = payload.updateFormList
    state.totalCounts = payload.totalCounts
  },
  ADD_CUSTOMER_QZ_UPDATE_FORM(state, customerQZUpdateForm) {
    state.customerQZUpdateFormList.unshift(customerQZUpdateForm)
    const index = customer.state.customerQZList.findIndex(x => x._id === customerQZUpdateForm.customer._id)
    const qz = customer.state.customerQZList[index]
    qz.comissionDivDev = customerQZUpdateForm.comissionDivDev
    qz.comissionDivMaintain = customerQZUpdateForm.comissionDivMaintain
    qz.comissionDivPayment = customerQZUpdateForm.comissionDivPayment
    qz.regionalCharger = customerQZUpdateForm.regionalCharger
    qz.salesVisibleMember = customerQZUpdateForm.salesVisibleMember
    qz.techVisibleMember = customerQZUpdateForm.techVisibleMember
    qz.devSales = customerQZUpdateForm.devSales
    qz.maintainSales = customerQZUpdateForm.maintainSales
    qz.paymentSales = customerQZUpdateForm.paymentSales
    Vue.set(customer.state.customerQZList, index, qz)
    state.totalCounts++
  },
  DELETE_CUSTOMER_QZ_UPDATE_FORM(state, id) {
    state.customerQZUpdateFormList = state.customerQZUpdateFormList.filter(e => e._id !== id)
    state.totalCounts--
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}